import { Socket } from "socket.io-client";
import { config } from "../../config";

/**
 * Registers a callback for incoming socket events
 * @param socket The socket instance
 * @param eventName The event name to listen for
 * @param callback The callback to execute when the event is received
 * @returns A cleanup function to remove the event listener
 */
export function onIncomingSocketEvent(
  socket: Socket | null,
  eventName: string,
  callback: (command: any) => void
): () => void {
  if (!config.socket.enable_sockets || !socket) {
    // console.debug(
    //   "MonitoringService: Sockets disabled, skipping event listener setup"
    // );
    return () => {}; // Return no-op cleanup function
  }

  socket.on(eventName, callback);
  return () => socket.off(eventName, callback);
}
